var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotAvailableWhite = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#6659FF"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M13 26C5.82 26 0 20.18 0 13 0 5.82 5.82 0 13 0c7.18 0 13 5.821 13 13 0 7.18-5.82 13-13 13z",
  transform: "translate(-267 -205) translate(267 205) translate(1 1)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 5.157L10.313 5.157M5.157 0L5.157 10.313",
  transform: "translate(-267 -205) translate(267 205) translate(1 1) rotate(45 -.407 18.553)"
}))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotAvailableWhite);
export default ForwardRef;